import { CurrencySchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetRevenueByCurrencyResponseSchema = oz.object({
  amountByCurrency: oz.record(CurrencySchema, oz.number()),
}).openapi('GetRevenueByCurrencyResponseSchema');

export type GetRevenueByCurrencyResponse = oz.TypeOf<typeof GetRevenueByCurrencyResponseSchema>;